import type { IFieldOptions } from '@axo/form/feature/form-input/types';
import {
  isCprOver18,
  validCpr,
} from '../../../../../utils/Denmark/validateDanishPnr';
import { SSN_REGEX } from '../../config/globals';

export const socialSecurityNumberFieldOptions = {
  registerOptions: {
    required: 'error.required',
    pattern: {
      value: SSN_REGEX,
      message: 'SocialSecurityNumber.error.format',
    },
    setValueAs: (value) => value.trim(),
    validate: (value) => {
      if (!isCprOver18(value)) {
        return 'SocialSecurityNumber.error.underage';
      }

      if (!validCpr(value)) {
        return 'SocialSecurityNumber.error.format';
      }
    },
  },
  tooltipValidation: {
    message: 'SocialSecurityNumber.tooltip',
  },
} satisfies IFieldOptions;
